import { render } from "./Purchase.vue?vue&type=template&id=e271404c&ts=true"
import script from "./Purchase.vue?vue&type=script&lang=ts"
export * from "./Purchase.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__